<template>
    <div>
        <div class="toptitle">用工形式</div>
        <div class="topcont">
            <div ref="bingtu" class="bingbox"></div>
            <div ref="bartu" class="barbox"></div>
        </div>


    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    data() {
        return {
            bingChart: null,
            barChart: null
        }
    },
    mounted() {
        this.getData()
        this.initCharts()
        // 监听窗口 resize，图表自适应
        window.addEventListener('resize', () => {
            this.bingChart.resize();
            this.barChart.resize();
        });
    },
    methods: {
        getData() {
            this.$api({
                url: '/api/central_control/employment_form',
                method: 'POST'
            }).then(res => {
                console.log(res, "用工paiqian")
                this.initBarCharts(res.data)

            })
        },
        // 柱状图
        initBarCharts(info) {

            this.barChart = echarts.init(this.$refs.bartu);
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['已派遣', '未派遣'], // 图例数据，与 series 中 name 对应
                    top: 0,
                    right: '5%',
                    show: true,
                    textStyle: {
                        color: '#fff'
                    },
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.1],
                    show: false
                },
                yAxis: {
                    type: 'category',
                    data: [''], // y 轴只有一个类目（因为是横向单组对比）
                    axisTick: { show: false },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                series: [
                    {
                        name: '已派遣', // 系列名称，与图例 data 中“已派遣”对应
                        type: 'bar',
                        data: [info.dispatched], // 已派遣的数据
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'right', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        barMinWidth: 20,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                [
                                    { offset: 0, color: '#F2AD7F' },
                                    { offset: 1, color: '#FEE9B3' }
                                ]
                            )
                        }
                    },
                    {
                        name: '未派遣', // 系列名称，与图例 data 中“未派遣”对应
                        type: 'bar',
                        data: [info.unassigned], // 未派遣的数据
                        // 核心：添加label配置，在柱子上方显示数据
                        label: {
                            show: true, // 显示标签
                            position: 'right', // 标签位置：顶部
                            textStyle: {
                                color: '#fff', // 标签颜色（根据背景调整）
                                fontSize: 12 // 标签字体大小
                            }
                        },
                        barMinWidth: 20,


                        itemStyle: {

                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 1,// 圆心 x、y（0.5 为中心），半径 0.5
                                [
                                    { offset: 0, color: '#2E67F2' },
                                    { offset: 1, color: '#1ce2ff' }
                                ]
                            )
                        }
                    }
                ]
            };
            // 使用配置项生成图表
            this.barChart.setOption(option);

        },
        // 饼图
        initCharts() {
            // 初始化图表
            this.bingChart = echarts.init(this.$refs.bingtu);
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [

                    {
                        // name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        startAngle: 90,
                        data: [
                            {
                                value: 32, name: '企业直签', itemStyle: {
                                    color: '#7A8AFB'
                                }
                            },
                            {
                                value: 68, name: '劳务派遣', itemStyle: {
                                    color: '#FF9D11'
                                }
                            },
                        ]
                    }
                ]
            };
            // 使用配置项生成图表
            this.bingChart.setOption(option);

        },
    },
}
</script>
<style lang="less" scoped>
.barbox {
    width: 100%;
    height: 180px;
    // height: 360px;
}

.bingbox {
    // width: 320px;
    width: 100%;
    height: 180px;
}

.topcont {
    background: url('@/assets/conbg.png') no-repeat 0 0/100% 100%;
    width: 100%;
    // height: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    // max-height: 385px;
    padding: 10px 26px 0;
    color: #fff;
    flex: 1;

}
</style>